import React, { Fragment, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Accordion from 'react-bootstrap/Accordion';
import Modal from 'react-bootstrap/Modal';

import GlobalContext from '../../context/global/globalContext';
import Header from '../layout/Header';
import ModalSignUpForm from '../layout/ModalSignUpForm';
import companyLogo from '../../assets/images/logo.png';
import testimonialOne from '../../assets/images/testimonial-1.jpg';
import testimonialTwo from '../../assets/images/testimonial-2.jpg';
import heshamPhoto from '../../assets/images/hesham.jpg';
import thursaunPhoto from '../../assets/images/thursaun.jpg';
import clientOne from '../../assets/images/client-1.png';
import clientTwo from '../../assets/images/client-2.png';
import clientThree from '../../assets/images/client-3.png';
import clientFour from '../../assets/images/client-4.png';
import clientFive from '../../assets/images/client-5.png';
import clientSix from '../../assets/images/client-6.png';
import clientSeven from '../../assets/images/client-7.png';
import clientEight from '../../assets/images/client-8.png';
import agenticGatewayImg from '../../assets/images/agentic-gateway.png';

import './Home.css';


const Home = () => {

    const history = useHistory();

    const globalContext = useContext(GlobalContext);

    const { auth: { isAuthenticated } } = globalContext;

    const [show, setShow] = useState(false);
    const [showGatewayModal, setShowGatewayModal] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    }

    const handleGatewayClose = () => setShowGatewayModal(false);
    const handleGatewayShow = () => setShowGatewayModal(true);

    return (
        <Fragment>
            <div className="scrollToTop circle">
                <i className="icon-up-open-big"></i>
            </div>
            <div className="page-wrapper">
                <Header />
                {/* Hero Section with Native Video Background */}
                <section className="hero-video-section">
                    <div className="hero-video-container">
                        <video
                            autoPlay
                            muted
                            loop
                            playsInline
                            poster="vendor/videos/video-banner-poster.jpg"
                            className="hero-video"
                        >
                            <source src="vendor/videos/background-video-banner.mp4" type="video/mp4" />
                            <source src="vendor/videos/background-video-banner.webm" type="video/webm" />
                        </video>
                        <div className="hero-overlay"></div>
                        <div className="hero-content">
                            <h1 className="hero-title">
                                <span className="logo-font">Advanced AI Engineers</span>
                                <br />On Demand
                            </h1>
                            <div className="separator-3 light"></div>
                            <p className="hero-subtitle">
                                We connect top-tier software engineers with innovative companies
                                <br />across the Research Triangle and beyond.
                                <br />Your next great hire is just a conversation away.
                            </p>
                            <span onClick={handleShow} className="btn btn-default btn-animated btn-lg" style={{cursor: 'pointer'}}>
                                Get Started <i className="fa fa-arrow-right"></i>
                            </span>
                        </div>
                    </div>
                </section>
                <div id="page-start"></div>
                <section id="about" className="main-container">
                    <div className="container">
                        <div className="row justify-content-lg-center">
                            <div className="col-lg-8">
                                <h2 className="text-center title">About <strong className="text-default">Us</strong></h2>
                                <div className="separator"></div>
                                <p className="large text-center">Variable Assign is a premier IT staffing and consulting firm specializing in placing
                                    top-tier software engineers, developers, and technical leaders with innovative companies across the nation.
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <h3 className="title">We Build <span className="text-default">Production-Grade</span> AI Systems</h3>
                                <p>We're not just consultants—we're practitioners. Our team actively contributes to the
                                    open-source AI ecosystem and builds the tools that power enterprise AI deployments.
                                </p>
                                <ul className="list-icons">
                                    <li className="object-non-visible" data-animation-effect="fadeInUpSmall" data-effect-delay="100">
                                        <i className="fa fa-check text-default"></i> Model Control Plane Architecture
                                    </li>
                                    <li className="object-non-visible" data-animation-effect="fadeInUpSmall" data-effect-delay="150">
                                        <i className="fa fa-check text-default"></i> Multi-Model Aggregation & Routing
                                    </li>
                                    <li className="object-non-visible" data-animation-effect="fadeInUpSmall" data-effect-delay="200">
                                        <i className="fa fa-check text-default"></i> Enterprise AI Governance & Audit
                                    </li>
                                    <li className="object-non-visible" data-animation-effect="fadeInUpSmall" data-effect-delay="250">
                                        <i className="fa fa-check text-default"></i> Production MLOps Best Practices
                                    </li>
                                </ul>
                                <p>Our battle-tested approach comes from real-world deployments at scale.
                                    We've built the infrastructure patterns that Fortune 500 companies trust.
                                </p>
                            </div>
                            <div className="col-lg-6 mb-4">
                                <div className="overlay-container overlay-visible">
                                    <img src={agenticGatewayImg} alt="Agentic AI Gateway" />
                                    <span onClick={handleGatewayShow} className="overlay-link" style={{cursor: 'pointer'}}>
                                        <i className="fa fa-external-link"></i>
                                    </span>
                                    <div className="overlay-bottom hidden-sm-down">
                                        <div className="text">
                                            <strong>Agentic AI Gateway</strong> — Our open-source model control plane.
                                            Click to learn how we're contributing to the AI community.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                </section>
                <section className="dark-translucent-bg pv-50 background-img-1"
                    style={{ backgroundPosition: "50% 10%" }}>
                    <div className="container container-choose">
                        <div className="row justify-content-lg-center">
                            <div className="col-lg-8">
                                <h2 className="text-center mt-4">Why <strong className="text-default">Choose</strong> Us?</h2>
                                <div className="separator"></div>
                                <p className="large text-center">Finding the right technical talent is hard. We make it easy by delivering pre-vetted,
                                    interview-ready candidates who match your technical requirements and company culture.
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="feature-box-2 object-non-visible" data-animation-effect="fadeInDownSmall" data-effect-delay="100">
                                            <span className="icon default-bg small">
                                                <i className="fa fa-bolt"></i>
                                            </span>
                                            <div className="body">
                                                <h4 className="title">Fast Turnaround</h4>
                                                <p>Get qualified candidates in front of your team within 48-72 hours.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="feature-box-2 object-non-visible " data-animation-effect="fadeInDownSmall" data-effect-delay="150">
                                            <span className="icon default-bg small">
                                                <i className="fa fa-filter"></i>
                                            </span>
                                            <div className="body">
                                                <h4 className="title">Pre-Vetted Talent</h4>
                                                <p>Every candidate passes technical assessments and culture-fit interviews before reaching you.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="feature-box-2 object-non-visible" data-animation-effect="fadeInDownSmall" data-effect-delay="200">
                                            <span className="icon default-bg small">
                                                <i className="fa fa-handshake-o"></i>
                                            </span>
                                            <div className="body">
                                                <h4 className="title">Flexible Engagement</h4>
                                                <p>Contract, contract-to-hire, or direct placement—whatever fits your needs.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="feature-box-2 object-non-visible animated object-visible " data-animation-effect="fadeInDownSmall" data-effect-delay="250">
                                            <span className="icon default-bg small">
                                                <i className="fa fa-shield"></i>
                                            </span>
                                            <div className="body">
                                                <h4 className="title">90-Day Guarantee</h4>
                                                <p>If a placement doesn't work out, we'll find a replacement at no additional cost.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Stats Counter Section */}
                <section className="pv-50 stats-container">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-6">
                                <div className="count-factor object-non-visible" data-animation-effect="fadeIn" data-effect-delay="100">
                                    <div className="count-number">
                                        <span className="count" data-from="0" data-to="500">500</span>+
                                    </div>
                                    <div className="count-description">
                                        <i className="fa fa-users"></i>
                                        <span className="count-title">Engineers Placed</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="count-factor object-non-visible" data-animation-effect="fadeIn" data-effect-delay="200">
                                    <div className="count-number">
                                        <span className="count" data-from="0" data-to="50">50</span>+
                                    </div>
                                    <div className="count-description">
                                        <i className="fa fa-building"></i>
                                        <span className="count-title">Enterprise Clients</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="count-factor object-non-visible" data-animation-effect="fadeIn" data-effect-delay="300">
                                    <div className="count-number">
                                        <span className="count" data-from="0" data-to="95">95</span>%
                                    </div>
                                    <div className="count-description">
                                        <i className="fa fa-trophy"></i>
                                        <span className="count-title">Placement Success</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="count-factor object-non-visible" data-animation-effect="fadeIn" data-effect-delay="400">
                                    <div className="count-number">
                                        <span className="count" data-from="0" data-to="10">10</span>+
                                    </div>
                                    <div className="count-description">
                                        <i className="fa fa-calendar"></i>
                                        <span className="count-title">Years Experience</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Academy Section with Tabs */}
                <section id="academy" className="light-gray-bg pv-50 clearfix">
                    <div className="container">
                        <div className="row justify-content-lg-center">
                            <div className="col-lg-8">
                                <h2 className="text-center title">Variable Assign <strong className="text-default">Academy</strong></h2>
                                <div className="separator"></div>
                                <p className="large text-center">
                                    Launch your tech career through our industry-driven training programs.
                                    As a consulting firm, we don't just train—we hire. Top graduates join our
                                    talent network and get placed with Fortune 500 clients.
                                </p>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-4">
                            <div className="col-lg-10">
                                <Tabs defaultActiveKey="bootcamp" className="mb-4 justify-content-center nav-pills">
                                    <Tab eventKey="bootcamp" title="Full-Stack Bootcamp">
                                        <div className="tab-content-inner p-4 white-bg shadow">
                                            <div className="row align-items-center">
                                                <div className="col-md-8">
                                                    <h4><i className="fa fa-laptop text-default mr-2"></i> Full-Stack Development Bootcamp</h4>
                                                    <p>Intensive, hands-on training in modern web development. Master the technologies that top companies demand.</p>
                                                    <ul className="list-icons">
                                                        <li><i className="fa fa-check text-default"></i> React, Node.js, TypeScript</li>
                                                        <li><i className="fa fa-check text-default"></i> AWS Cloud Services & Deployment</li>
                                                        <li><i className="fa fa-check text-default"></i> Real-world project portfolio</li>
                                                        <li><i className="fa fa-check text-default"></i> 1-on-1 mentorship with senior engineers</li>
                                                    </ul>
                                                </div>
                                                <div className="col-md-4 text-center">
                                                    <div className="default-bg p-4 rounded">
                                                        <h5 className="text-white mb-0">Graduate Job-Ready</h5>
                                                        <p className="text-white-50 mb-0">in 12-16 weeks</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="certification" title="AWS Certification">
                                        <div className="tab-content-inner p-4 white-bg shadow">
                                            <div className="row align-items-center">
                                                <div className="col-md-8">
                                                    <h4><i className="fa fa-certificate text-default mr-2"></i> AWS Certification Prep</h4>
                                                    <p>Get cloud-certified and join the ranks of in-demand cloud architects and engineers.</p>
                                                    <ul className="list-icons">
                                                        <li><i className="fa fa-check text-default"></i> Solutions Architect Associate</li>
                                                        <li><i className="fa fa-check text-default"></i> Developer Associate</li>
                                                        <li><i className="fa fa-check text-default"></i> SysOps Administrator</li>
                                                        <li><i className="fa fa-check text-default"></i> Practice exams & hands-on labs</li>
                                                    </ul>
                                                </div>
                                                <div className="col-md-4 text-center">
                                                    <div className="default-bg p-4 rounded">
                                                        <h5 className="text-white mb-0">92% Pass Rate</h5>
                                                        <p className="text-white-50 mb-0">on first attempt</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="hire-to-train" title="Hire-to-Train">
                                        <div className="tab-content-inner p-4 white-bg shadow">
                                            <div className="row align-items-center">
                                                <div className="col-md-8">
                                                    <h4><i className="fa fa-briefcase text-default mr-2"></i> Hire-to-Train Program</h4>
                                                    <p>Get hired before you graduate. Train as a Variable Assign employee and deploy directly to client projects.</p>
                                                    <ul className="list-icons">
                                                        <li><i className="fa fa-check text-default"></i> Paid training from day one</li>
                                                        <li><i className="fa fa-check text-default"></i> Benefits during training period</li>
                                                        <li><i className="fa fa-check text-default"></i> Guaranteed placement upon completion</li>
                                                        <li><i className="fa fa-check text-default"></i> Ongoing career support</li>
                                                    </ul>
                                                </div>
                                                <div className="col-md-4 text-center">
                                                    <div className="default-bg p-4 rounded">
                                                        <h5 className="text-white mb-0">98% Placement</h5>
                                                        <p className="text-white-50 mb-0">for program graduates</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="pv-50 curriculum">
                    <div className="container">
                        <div className="row justify-content-lg-center">
                            <div className="col-lg-8">
                                <h2 className="text-center mt-4">Our
                                    <strong className="text-default"> Services</strong>
                                </h2>
                                <div className="separator"></div>
                                <p className="large text-center">We deliver AI talent and solutions that transform your business.
                                    From strategy to production deployment, we've got you covered.
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="pv-20 ph-20 feature-box-2 light-gray-bg boxed shadow object-non-visible" data-animation-effect="fadeInDownSmall"
                                    data-effect-delay="100">
                                    <span className="icon without-bg">
                                        <i className="fa fa-microchip"></i>
                                    </span>
                                    <div className="body">
                                        <h4 className="title">AI Engineers</h4>
                                        <p>Machine learning engineers, LLM specialists, and AI architects fluent in TensorFlow, PyTorch, and OpenAI.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="pv-20 ph-20 feature-box-2 light-gray-bg boxed shadow object-non-visible" data-animation-effect="fadeInDownSmall"
                                    data-effect-delay="150">
                                    <span className="icon without-bg">
                                        <i className="fa fa-cogs"></i>
                                    </span>
                                    <div className="body">
                                        <h4 className="title">MLOps & Infrastructure</h4>
                                        <p>Production ML pipelines, model monitoring, and AI infrastructure on AWS, Azure, and GCP.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="pv-20 ph-20 feature-box-2 light-gray-bg boxed shadow object-non-visible" data-animation-effect="fadeInDownSmall"
                                    data-effect-delay="200">
                                    <span className="icon without-bg">
                                        <i className="fa fa-comments"></i>
                                    </span>
                                    <div className="body">
                                        <h4 className="title">NLP & Chatbots</h4>
                                        <p>Conversational AI, LangChain experts, and custom GPT integrations for your business.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="pv-20 ph-20 feature-box-2 light-gray-bg boxed shadow object-non-visible" data-animation-effect="fadeInDownSmall"
                                    data-effect-delay="250">
                                    <span className="icon without-bg">
                                        <i className="fa fa-eye"></i>
                                    </span>
                                    <div className="body">
                                        <h4 className="title">Computer Vision</h4>
                                        <p>Image recognition, video analytics, and visual AI specialists for manufacturing, retail, and healthcare.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="pv-20 ph-20 feature-box-2 light-gray-bg boxed shadow object-non-visible" data-animation-effect="fadeInDownSmall"
                                    data-effect-delay="300">
                                    <span className="icon without-bg">
                                        <i className="fa fa-lightbulb-o"></i>
                                    </span>
                                    <div className="body">
                                        <h4 className="title">AI Strategy Consulting</h4>
                                        <p>Identify high-impact AI use cases, build roadmaps, and assess technical feasibility for your organization.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="pv-20 ph-20 feature-box-2 light-gray-bg boxed shadow object-non-visible" data-animation-effect="fadeInDownSmall"
                                    data-effect-delay="350">
                                    <span className="icon without-bg">
                                        <i className="fa fa-line-chart"></i>
                                    </span>
                                    <div className="body">
                                        <h4 className="title">Data Science & Analytics</h4>
                                        <p>Predictive modeling, data pipelines, and business intelligence to drive data-driven decisions.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* FAQ Section */}
                <section id="faq" className="pv-50 light-gray-bg">
                    <div className="container">
                        <div className="row justify-content-lg-center">
                            <div className="col-lg-8">
                                <h2 className="text-center title">Frequently Asked <strong className="text-default">Questions</strong></h2>
                                <div className="separator"></div>
                                <p className="large text-center">
                                    Get answers to common questions about our AI consulting services.
                                </p>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-4">
                            <div className="col-lg-8">
                                <Accordion defaultActiveKey="0" className="faq-accordion">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            <i className="fa fa-question-circle text-default mr-2"></i>
                                            How quickly can you provide AI engineers for my project?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            We typically present qualified candidates within 48-72 hours. Our pre-vetted talent network includes engineers who have already passed technical assessments, allowing for rapid deployment to your project.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                            <i className="fa fa-question-circle text-default mr-2"></i>
                                            What AI/ML technologies do your engineers specialize in?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            Our engineers are proficient in TensorFlow, PyTorch, scikit-learn, OpenAI APIs, LangChain, and cloud ML services (AWS SageMaker, Azure ML, Google Vertex AI). We also have specialists in computer vision, NLP, and generative AI.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>
                                            <i className="fa fa-question-circle text-default mr-2"></i>
                                            Do you offer consulting for AI strategy, or just staffing?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            Both. We offer AI strategy consulting to help you identify high-impact use cases, assess technical feasibility, and create implementation roadmaps. We can then provide the engineering talent to execute on that strategy.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>
                                            <i className="fa fa-question-circle text-default mr-2"></i>
                                            What is your 90-day placement guarantee?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            If a placement doesn't work out within the first 90 days for any reason, we'll find a replacement candidate at no additional cost. We stand behind the quality of our placements.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header>
                                            <i className="fa fa-question-circle text-default mr-2"></i>
                                            Can you help integrate AI into our existing production systems?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            Absolutely. Our engineers specialize in production-grade AI integration, including MLOps pipelines, model monitoring, A/B testing frameworks, and ensuring AI systems meet enterprise security and compliance requirements.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Call to Action */}
                <section>
                    <div className="dark-translucent-bg footer-top animated-text default-hovered"
                        style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="call-to-action text-center text-md-left">
                                        <h2 className="mt-3">Ready to Transform Your Business with AI?</h2>
                                        <h2 className="mt-3">Let's Build Something Extraordinary Together.</h2>
                                    </div>
                                </div>
                                <div className="col-md-4 d-flex align-items-center justify-content-center justify-content-md-end">
                                    <span onClick={handleShow} className="btn btn-animated btn-lg btn-gray-transparent" style={{cursor: 'pointer'}}>
                                        Get Started <i className="fa fa-arrow-right pl-20"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="partners" className="section pv-50 light-gray-bg">
                    <div className="container">
                        <div className="row justify-content-lg-center">
                            <div className="col-lg-8 text-center">
                                <h2 className="title">Success Stories from <strong className="text-default">Our Network</strong></h2>
                                <div className="separator"></div>
                            </div>
                        </div>
                    </div>
                    <div className="owl-carousel content-slider space-top">
                        <div className="container">
                            <div className="row justify-content-md-center">
                                <div className="col-md-8">
                                    <div className="testimonial text-center">
                                        <div className="testimonial-image">
                                            <img src={heshamPhoto} alt="Hesham Gad" title="Hesham Gad" className="rounded-circle" />
                                        </div>
                                        <h3 className="mt-3">We Integrate AI into Production Systems</h3>
                                        <div className="separator"></div>
                                        <div className="testimonial-body">
                                            <blockquote>
                                                <p>Variable Assign delivered exactly what we needed—engineers who understood both AI and enterprise systems.
                                                    They helped us deploy ML models into production with confidence.
                                                </p>
                                            </blockquote>
                                            <div className="testimonial-info-1">- Hesham Gad</div>
                                            <div className="testimonial-info-2">AI Solutions Architect</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row justify-content-md-center">
                                <div className="col-md-8">
                                    <div className="testimonial text-center">
                                        <div className="testimonial-image">
                                            <img src={thursaunPhoto} alt="Thursaun Canton" title="Thursaun Canton" className="rounded-circle" />
                                        </div>
                                        <h3 className="mt-3">From Academy to Enterprise</h3>
                                        <div className="separator"></div>
                                        <div className="testimonial-body">
                                            <blockquote>
                                                <p>The Variable Assign Academy changed my career trajectory. The training was hands-on and
                                                    directly applicable. Now I'm working with Fortune 500 clients on cutting-edge AI projects.
                                                </p>
                                            </blockquote>
                                            <div className="testimonial-info-1">- Thursaun Canton</div>
                                            <div className="testimonial-info-2">Senior Software Engineer</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="clients-container">
                            <div className="clients owl-carousel client-vendors">
                                <div className="client-image object-non-visible" data-animation-effect="fadeIn" data-effect-delay="100">
                                    <a href="/#">
                                        <img src={clientOne} alt="Variable Assign " />
                                    </a>
                                </div>
                                <div className="client-image object-non-visible" data-animation-effect="fadeIn" data-effect-delay="200">
                                    <a href="/#">
                                        <img src={clientTwo} alt="Variable Assign " />
                                    </a>
                                </div>
                                <div className="client-image object-non-visible" data-animation-effect="fadeIn" data-effect-delay="300">
                                    <a href="/#">
                                        <img src={clientThree} alt="Variable Assign " />
                                    </a>
                                </div>
                                <div className="client-image object-non-visible" data-animation-effect="fadeIn" data-effect-delay="400">
                                    <a href="/#">
                                        <img src={clientFour} alt="Variable Assign " />
                                    </a>
                                </div>
                                <div className="client-image object-non-visible" data-animation-effect="fadeIn" data-effect-delay="500">
                                    <a href="/#">
                                        <img src={clientFive} alt="Variable Assign " />
                                    </a>
                                </div>
                                <div className="client-image object-non-visible" data-animation-effect="fadeIn" data-effect-delay="600">
                                    <a href="/#">
                                        <img src={clientSix} alt="Variable Assign " />
                                    </a>
                                </div>
                                <div className="client-image object-non-visible" data-animation-effect="fadeIn" data-effect-delay="700">
                                    <a href="/#">
                                        <img src={clientSeven} alt="Variable Assign " />
                                    </a>
                                </div>
                                <div className="client-image object-non-visible" data-animation-effect="fadeIn" data-effect-delay="800">
                                    <a href="/#">
                                        <img src={clientEight} alt="Variable Assign " />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <footer id="getstarted" className="clearfix">
                    <div className="footer">
                        <div className="container">
                            <div className="footer-inner">
                                <div className="row justify-content-lg-center">
                                    <div className="col-lg-6">
                                        <div className="footer-content">
                                            <div className="logo-footer">
                                                <img className="mx-auto" id="logo-footer" src={companyLogo} alt="Variable Assign " />
                                            </div>
                                            <p className="text-center">Get more information contact our coding counselors and get started with your career in software engineering.
                                                We provide a seamless transition from the school house to the workforce as a Variable Assign employee.
                                            </p>
                                            <ul className="list-inline mb-20">
                                                <li className="list-inline-item">
                                                    <i className="text-default fa fa-map-marker pr-1"></i> 555 Fayetteville Street, 27601
                                                </li>
                                                <li className="list-inline-item">
                                                    <i className="text-default fa fa-phone pl-10 pr-1"></i> +1 919.386.9497
                                                </li>
                                                <li className="list-inline-item">
                                                    <a href="mailto:info@variableassign.com.com" className="link-dark">
                                                        <i className="text-default fa fa-envelope-o pl-10 pr-1"></i> info@variableassign.com</a>
                                                </li>
                                            </ul>
                                            <div className="separator-2"></div>
                                            <ul className="social-links circle margin-clear animated-effect-1 text-center">
                                                <li className="facebook">
                                                    <a target="_blank" rel="noreferrer" href="https://www.facebook.com/variableassigntechnology">
                                                        <i className="fa fa-facebook"></i>
                                                    </a>
                                                </li>
                                                <li className="twitter">
                                                    <a target="_blank" rel="noreferrer" href="http://www.twitter.com">
                                                        <i className="fa fa-twitter"></i>
                                                    </a>
                                                </li>
                                                <li className="googleplus">
                                                    <a target="_blank" rel="noreferrer" href="http://plus.google.com">
                                                        <i className="fa fa-google-plus"></i>
                                                    </a>
                                                </li>
                                                <li className="linkedin">
                                                    <a target="_blank" rel="noreferrer" href="http://www.linkedin.com">
                                                        <i className="fa fa-linkedin"></i>
                                                    </a>
                                                </li>
                                                <li className="youtube">
                                                    <a target="_blank" rel="noreferrer" href="https://www.youtube.com">
                                                        <i className="fa fa-youtube"></i>
                                                    </a>
                                                </li>
                                                <li className="instagram">
                                                    <a target="_blank" rel="noreferrer" href="http://www.instagram.com">
                                                        <i className="fa fa-instagram"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="subfooter">
                        <div className="container">
                            <div className="subfooter-inner">
                                <div className="row">
                                    <div className="col-md-12">
                                        <p className="text-center">Copyright© 2017 The Variable Assign Academy. All Rights Reserved</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ModalSignUpForm
                        show={show}
                        onClose={handleClose}
                        onShow={handleShow} />

                    {/* Agentic AI Gateway Modal */}
                    <Modal
                        size="lg"
                        show={showGatewayModal}
                        onHide={handleGatewayClose}
                        centered
                    >
                        <Modal.Header closeButton className="default-bg">
                            <Modal.Title className="text-white">
                                <i className="fa fa-code-fork mr-2"></i> Agentic AI Gateway
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="p-4">
                            <h4 className="text-default mb-3">Contributing to the AI Community</h4>
                            <p className="lead">
                                We believe in giving back. That's why we've open-sourced our <strong>Agentic AI Gateway</strong> —
                                a model control plane for production AI systems.
                            </p>

                            <div className="row mt-4">
                                <div className="col-md-6">
                                    <h5><i className="fa fa-sitemap text-default mr-2"></i> Model Control Plane</h5>
                                    <p>A standardized layer that sits between your applications and AI models,
                                        providing unified access, governance, and observability.</p>
                                </div>
                                <div className="col-md-6">
                                    <h5><i className="fa fa-random text-default mr-2"></i> Multi-Model Aggregation</h5>
                                    <p>Route requests to the right model based on cost, latency, or capability.
                                        Support OpenAI, Anthropic, local models, and more.</p>
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <h5><i className="fa fa-shield text-default mr-2"></i> Enterprise Governance</h5>
                                    <p>Built-in audit logging, rate limiting, and policy enforcement
                                        for compliant AI deployments.</p>
                                </div>
                                <div className="col-md-6">
                                    <h5><i className="fa fa-plug text-default mr-2"></i> MCP Compatible</h5>
                                    <p>Full support for the Model Context Protocol (MCP) standard,
                                        enabling seamless tool and context integration.</p>
                                </div>
                            </div>

                            <div className="mt-4 p-3 light-gray-bg rounded">
                                <h5 className="mb-2"><i className="fa fa-github text-default mr-2"></i> Open Source</h5>
                                <p className="mb-2">
                                    The Agentic AI Gateway is available on GitHub. We welcome contributions
                                    from the community to help shape the future of production AI infrastructure.
                                </p>
                                <a
                                    href="https://github.com/VariableAssignTechnology/agentic-ai-gateway"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-default btn-animated"
                                >
                                    View on GitHub <i className="fa fa-arrow-right"></i>
                                </a>
                            </div>
                        </Modal.Body>
                    </Modal>
                </footer>
            </div>

        </Fragment>

    )
}

export default Home